import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7feafdce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { class: "footer-content__left left-content" }
const _hoisted_3 = { class: "left-content__about about" }
const _hoisted_4 = { class: "about__logo project-logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "project-logo__snedson" }, "Snedson"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "project-logo__snotra" }, "Snotra")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about__description" }, " Snotra - школьный агрегатор, собирающий все необходимое для удобной учебы в одном месте: измененное и стандартное расписание уроков и звонков, домашние задания, уведомления и информацию о посещаемости учащихся. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2020-2026 Snotra Educational Solutions", -1))
const _hoisted_9 = { class: "left-content__links" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://vk.com/lkchnv",
    target: "_blank"
  }, "Связь с владельцами проекта")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-content__right" }, null, -1))

import snotraIcon from '@/assets/img/snotraIconSmall.png';
import SquiggleDivider from '@/common/components/snedson-material-components/squiggle-divider/squiggle-divider.vue';
import { getBaseUrl } from '@/http/api/';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_foooter = _resolveComponent("foooter")!

  return (_openBlock(), _createBlock(_component_foooter, null, {
    default: _withCtx(() => [
      _createVNode(SquiggleDivider),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", { src: _unref(snotraIcon) }, null, 8, _hoisted_5),
              _hoisted_6
            ]),
            _hoisted_7,
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: `${_unref(getBaseUrl)()}legal/EulaAndPrivacyPolicy.pdf`,
                target: "_blank"
              }, "Пользовательское соглашение и политика конфиденциальности", 8, _hoisted_10)
            ]),
            _hoisted_11
          ])
        ]),
        _hoisted_12
      ])
    ]),
    _: 1
  }))
}
}

})